import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import Button from '../../../components/common/Button';
import FormMessage from '../../FormMessage';
import { showList as dispatchShowList } from '../actions';
import {
  countOpenBets,
  getCurrentBetCashedOutPrice,
  getFormattedCurrentBet,
  hasLivescoresOrScoreboards,
  isCashInPossible
} from '../selectors';
import SelectionConnect from './Selection';
import SingleBetNavigationConnect from './SingleBetNavigation';
import CashInWidget from '../../layout/CashInWidget';

async function queryBet(betId, setQualifyingFreeBet) {
  try {
    const response = await axios.get(`${api_config.bet_tracker_api}/vouchers/betId/${betId}`);
    if (response.data === 1) {
      setQualifyingFreeBet(true);
    } else {
      setQualifyingFreeBet(false);
    }
  } catch (error) {
    setQualifyingFreeBet(false);
  }
}

export const SingleBet = ({
  bet,
  cashedOutPrice,
  betsCount,
  showList,
  shouldDisplayDisclosure,
  showCashInWidget
}) => {
  const {
    betStakePerLine,
    betType,
    selections,
    slipId
  } = bet;
  const [inPlay, setInPlay] = useState(false);
  const [isSettled, setIsSettled] = useState(false);
  const [qualifyingFreeBet, setQualifyingFreeBet] = useState(true);
  const [queryBetCalled, setQueryBetCalled] = useState(false);
  const inPlayOrSettled = inPlay || isSettled;

  if (queryBetCalled === false) {
    queryBet(slipId, setQualifyingFreeBet);
    setQueryBetCalled(true);
  }

  const enableCashIn = (!qualifyingFreeBet || inPlayOrSettled);

  return (
    <div className="open-bet-single">
      <main className="open-bet-single__main">
        {
          (betsCount > 1)
            ? <SingleBetNavigationConnect />
            : null
        }
        <div className="open-bet-single-header">
          <div className="container--fixed">
            <div className="open-bet-single-header__cells">
              <div
                className="open-bet-single-header__cell open-bet-single__price"
              >
                {betStakePerLine}
              </div>
              <div
                className="open-bet-single-header__cell open-bet-single__type"
              >
                {betType}
              </div>
            </div>
          </div>
        </div>
        <div className="container--fixed">
          <FormMessage className="open-bet-single-message" slotId="live_events" />
          <FormMessage className="open-bet-single-message" slotId="default" />
          <FormMessage className="open-bet-single-message" slotId="congratulations" />
          <div className="open-bet-single__selections">
            {
              selections.map(selectionUniqueId => (
                <SelectionConnect selectionUniqueId={selectionUniqueId} key={selectionUniqueId} setInPlay={setInPlay} setIsSettled={setIsSettled} setQualifyingFreeBet={setQualifyingFreeBet} setQueryBetCalled={setQueryBetCalled} />
              ))
            }
          </div>
          {
            cashedOutPrice
              ? (
                <Button className="open-bet-single__list-all" onClick={showList}>
                  List all open bets
                </Button>
              )
              : null
          }
        </div>
        {
          shouldDisplayDisclosure ? (
            <div className="open-bet-single__disclaimer">
              Live scores and stats are a guide only
            </div>
          ) : null
        }
      </main>
      {
        showCashInWidget
          ? <CashInWidget enableCashIn={enableCashIn} />
          : null
      }
    </div>
  );
};

SingleBet.propTypes = {
  bet: PropTypes.shape({
    slipId: PropTypes.string.isRequired,
    betStakePerLine: PropTypes.string.isRequired,
    betType: PropTypes.string.isRequired,
    betPotentialPayout: PropTypes.string.isRequired,
    betStake: PropTypes.string.isRequired,
    betCashInPrice: PropTypes.string,
    freeBet: PropTypes.bool.isRequired,
    selections: PropTypes.object.isRequired,
  }).isRequired,
  cashedOutPrice: PropTypes.string,
  betsCount: PropTypes.number.isRequired,
  showList: PropTypes.func.isRequired,
  shouldDisplayDisclosure: PropTypes.bool.isRequired,
  showCashInWidget: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  bet: getFormattedCurrentBet(state),
  cashedOutPrice: getCurrentBetCashedOutPrice(state),
  betsCount: countOpenBets(state),
  shouldDisplayDisclosure: hasLivescoresOrScoreboards(state),
  showCashInWidget: isCashInPossible(state)
});

const mapDispatchToProps = {
  showList: dispatchShowList,
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleBet);
